export default __webpack_public_path__ + "media/images/front/about/features/money-eb3533eaaa2c941ab4c6bc61b84dd98e.png";